import { Outlet } from "react-router-dom"


export default function WalletPage() {
  return (
    <div className="px-1 sm:pl-0 py-4 sm:pr-4 flex flex-col w-full bg-customDark">
      <Outlet />
    </div>
  )
}
